export default "__VITE_ASSET__BoCKPZY3__"